var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "user-licenses-table-cell" },
    _vm._l(_setup.licenses, function (license) {
      return _c(
        "span",
        {
          key: license.id,
          class: [
            "license",
            license.role
              ? license.role
                  .split(" ")
                  .map((word) => word.toLowerCase())
                  .join("-")
              : "",
          ],
        },
        [
          _c("span", [_vm._v(_vm._s(license.role))]),
          _vm._v(" "),
          license.removeDate
            ? _c("span", { style: { fontSize: "10px" } }, [
                _vm._v(
                  "\n      (removes on " +
                    _vm._s(
                      _setup.dateFilter(license.removeDate, "MM/dd/yyyy")
                    ) +
                    ")\n    "
                ),
              ])
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }